import { style } from "@vanilla-extract/css";
import { buttonStyles } from "plos/src/components/buttons/Button/Button.recipe";
import {
  columnStyles,
  tableStyles,
} from "plos/src/components/Table/tables.css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";

export const leagueTypeTableStyles = style([
  tableStyles,
  {
    tableLayout: "fixed",
  },
]);

const sharedColStyles = style([
  columnStyles,
  {
    padding: `${vars.space.xs} ${vars.space["2xs"]}`,
    "@media": {
      [`screen and (min-width:${breakpoints[1]})`]: {
        padding: vars.space.xs,
      },
    },
  },
]);

export const leagueColStyles = style([
  sharedColStyles,
  {
    width: "43%",
    textAlign: "start",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "68%",
      },
    },
  },
]);

export const currentRankColStyles = style([
  sharedColStyles,
  {
    width: "23%",
    textAlign: "end",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "12%",
      },
    },
  },
]);

export const lastRankColStyles = style([
  sharedColStyles,
  {
    width: "21%",
    textAlign: "end",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "12%",
      },
    },
  },
]);

export const optionsColStyles = style([
  sharedColStyles,
  {
    width: "13%",
    textAlign: "end",
    "@media": {
      [`screen and (min-width: ${breakpoints[2]})`]: {
        width: "8%",
      },
    },
  },
]);

export const cellStyles = style({
  padding: `${vars.space.m} ${vars.space["2xs"]}`,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      padding: `${vars.space.m} ${vars.space.xs}`,
    },
  },
});

export const rankCellStyles = style([
  cellStyles,
  {
    textAlign: "end",
  },
]);

export const optionsCellStyles = style([
  cellStyles,
  {
    textAlign: "end",
  },
]);

export const joinButtonStyles = style([
  buttonStyles({ appearance: "tonal", size: "small" }),
  {
    display: "inline-flex",
    padding: `${vars.space.xs} ${vars.space.xs}`,
    fontSize: vars.fontSizes.body.xs,
    "@media": {
      [`screen and (min-width:${breakpoints[1]})`]: {
        padding: `${vars.space.xs} ${vars.space.s}`,
        fontSize: vars.fontSizes.body.s,
      },
    },
  },
]);

export const currentRankContent = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: vars.space.xs,
});
